module.exports = "            <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 kill-sides\">\r\n                <h3 class=\"thin\">{{ctrl.header}}: {{ctrl.selectedLink}}</h3>\r\n                <p class=\"description\">{{ctrl.description}}</p>\r\n            </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/header-section/header-section.html
// module id = 87
// module chunks = 0